import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f8def17")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_radio_button_group = _resolveComponent("radio-button-group")
  const _component_alert_message = _resolveComponent("alert-message")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_radio_button_group, {
      "group-id": $props.groupId,
      radios: $props.radios,
      required: $props.required,
      modelValue: $props.modelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString($props.title), 1)
      ]),
      _: 1
    }, 8, ["group-id", "radios", "required", "modelValue"]),
    ($props.validation)
      ? (_openBlock(), _createBlock(_component_alert_message, { key: 0 }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString($props.validation), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
})